import React, { Component, Fragment } from 'react';
import { _delete, get, patch, postWithHeaders, postWithHeadersResponse, put, putWithHeadersResponse } from '../../../server/actions'
import { currency_symbol } from '../../../server/constants'
import Modal from 'react-modal'
import ToggleDisplay from 'react-toggle-display';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import ReactTable from 'react-table'
import ReactTooltip from 'react-tooltip'
import moment from 'moment';
import '../../../../src/assets/css/react-table.css'
import { BeatLoader } from 'react-spinners';
import 'react-tabs/style/react-tabs.css';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import NotificationSystem from 'react-notification-system';
import Phone from 'react-phone-number-input';
import '../../../assets/css/phoneInputStyles.css'
import '../../../assets/css/rrui.css'
import { dial_code, mobileNoLength } from '../../../server/constants'
import {
    _addNotification, _addNotificationError, formatDate,
    numberOnly, getGradeNumberByText, getModuleEnum, getAccessLevelByModule, getSchoolGrades
} from '../../../server/util'
import $ from "jquery";
import FreeReducedStudetsList from '../../SchoolAdmin/SetUpSchool/freeReducedStudetsList';
import CustomSubmit from '../../Misc/customSubmit';
import TmExportExcel from '../../Misc/tmExportExcel/tmExportExcel';
import AccountHistoryDistrict from './accountHistoryDistrict';
import StudentDepositsDistrict from './studentDepositsDistrict';
import ViewOrdersDistrict from './viewOrderDistrict';
import BenefitsIssuanceReportDistrict from './benefitsIssuanceReportDistrict';
import StudentPurchaseReportDistrict from './studentPurchaseReportDistrict';
import './studentLookUpDistrict.css';
import { getLoginDistrictInfo, getSchoolYearOptions } from "../../../server/utilDistrict";
import _, { groupBy } from 'lodash';
const defaultImg = require('../../../assets/img/student-icon.png');
var converter = require('number-to-words');
const download = require('downloadjs');
const CheckboxTable = checkboxHOC(ReactTable);
let searchedSchool = [];
let teachers = [];
let studentsByGrade = [];
// School year is stored as the starting year (e.g. 2026 => "2026-27").
// The current (newest) year existing across the district's connected schools.
const getActiveSchoolYear = () => getSchoolYearOptions()[0];
const formatSchoolYearLabel = (y) => `${y}-${(y + 1).toString().slice(-2)}`;
const parentEmailsEnum = {
    primary: 'Primary email',
    alternate: 'Alternate email',
    both: 'Both emails'
}

const customStyles = {
    content: {
        maxHeight: '550px',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '90%',
        transform: 'translate(-50%, -50%)'
    }
};
const editStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '40%',
        transform: 'translate(-50%, -50%)'
    }
};
const deleteStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)'
    }
};
const eligibleCheck = {
    width: '18px',
    height: '18px',
    verticalAlign: 'middle',
    margin: '5px',
    cursor: 'pointer'
};
let teacherNames = [];
const modEnum = getModuleEnum();
let gradeList = [];
class StudentLookUpDistrict extends Component {

    constructor(props) {
        super(props);
        this.state = {
            mobileLength: mobileNoLength(),
            //tabIndex:0,
            studentsCount: 0,
            selectedSchool: this.props.selectSchool || '0',
            accountHistoryData: [],
            loading: false,
            deletedStudents: [],
            currentPage: 0,
            students: [],
            currentGrade: '0',
            phone: '',
            search: '',
            lookupStatus: "false",
            eligibilityCodes: [],
            userInfo: getLoginDistrictInfo(),
            activeSchoolYear: getActiveSchoolYear(),
            selectedSchoolYear: getActiveSchoolYear(),
            schoolYearOptions: getSchoolYearOptions(),
            schoolObj: groupBy((this.props.schoolList || []), 'schoolId'),
            editStudent: {
                "loggedUser": "",
                "firstName": '',
                "lastName": '',
                "studentId": '',
                "gradeName": '',
                "mobileNo": "",
                "teacherName": '',
                "decisionReason": '',
                "category": '',
                "isReducePriceEligible": false,
                "isFreeMealEligible": false,
                "defaultNotifyEmail": parentEmailsEnum.both,
                "schoolYear": '',
                "pin": '',
                "freezePreOrder": false,
                "displayRecId": '',
                "accBalance": '',
                "parentuser": {
                    "userName": "",
                    "parentAltEmail": ""
                },
                "numberStreetApt": "",
                "cityStateZip": "",
                hasMilkCard: false,
                beforeCare: false,
                additionalNotes: '',
                actualPrg: ''

            },
            updateStudent: {},
            change: {},
            studentsForm: [{
                "loggedUser": "", //get from sessionStorage or context
                "firstName": '',
                "lastName": '',
                "studentId": '',
                "gradeName": '',
                "mobileNo": "",
                "teacherName": '',
                "decisionReason": '',
                "category": '',
                "isReducePriceEligible": false,
                "isFreeMealEligible": false,
                "defaultNotifyEmail": parentEmailsEnum.both,
                "schoolYear": '',
                "parentuser": {
                    "loggedUser": "",  //get from sessionStorage or context
                    "userName": "",
                    "parentAltEmail": ""
                },
                "numberStreetApt": "",
                "cityStateZip": "",
                hasMilkCard: false,
                beforeCare: false,
                additionalNotes: '',
                actualPrg: ''
            }],
            data: [],
            columns: [],
            selection: [],
            selectionStuList: {},
            selectAll: false,
            selectType: 'checkbox',
            tabIndex: 0,
            modelTabIndex: 0,
            addModalIsOpen: false,
            editModalIsOpen: false,
            deleteModalIsOpen: false,
            show: false,
            studentCount: 0,
            allStudentData: [],
            result: [],
            showNewStudentOnly: false
        };
        this.activateStudent = this.activateStudent.bind(this);
        this.previousPage = this.previousPage.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.deleteStudent = this.deleteStudent.bind(this);

        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.getDataByGrade = this.getDataByGrade.bind(this);
        this.getColumns = this.getColumns.bind(this);
        this.handleChangeEditStudent = this.handleChangeEditStudent.bind(this);
        this.changeFreeOrRedPrice = this.changeFreeOrRedPrice.bind(this);
        this.changeB_ACare = this.changeB_ACare.bind(this);
        this.buildDataFormatForExport = this.buildDataFormatForExport.bind(this);
    };
    componentWillMount = () => {
        this.props.changeShowHideSchoolFitler(false);
    }
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            schoolObj: groupBy((nextProps.schoolList || []), 'schoolId'),
            selectedSchool: nextProps.selectSchool
        }, () => {
            this.filterList()
        })
    }

    previousPage = () => {
        if (this.state.currentPage !== 0)
            this.setState({ currentPage: this.state.currentPage - 1 })
    }
    nextPage = () => {
        if ((this.state.currentPage + 1) * 20 < this.state.students.length)
            this.setState({ currentPage: this.state.currentPage + 1 })
    }
    getEligibilityCodes = () => {
        const _self = this;
        get(`/eligibilityCodes/search/findByIsActive?isActive=true&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.setState({
                eligibilityCodes: data._embedded.eligibilityCodes, loading: false
            });

        }).catch(
            (error) => {
                this.setState({
                    eligibilityCodes: [], loading: false
                });
                console.log('Eligibility Codes errors:', error)
            }
        )
    }
    filterList = (isNewOnly) => {
        const { accountHistoryData, search, selectedSchool } = this.state;
        let searchedSchool = [];
        let schoolFilter = accountHistoryData.filter(s => {
            return selectedSchool == '0' ? true : (s.mSchoolId == selectedSchool) ? true : false;
        }).filter(s => {
            return isNewOnly ? ((s.sisNewStudent == true) ? true : false) : true;
        });
        if (search.length > 0) {
            schoolFilter.forEach(obj => {
                const { schoolObj } = this.state;
                const schoolName = ((schoolObj[obj.mSchoolId] || [])[0] || {}).schoolName || '';
                // const studentName = `${(obj.lastName || '')} ${(obj.firstName || '')}`;
                if (obj.studentId != null && (obj.studentId.toLowerCase()).startsWith(search.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (((obj.firstName || '').toLowerCase()).startsWith(search.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (((obj.lastName || '').toLowerCase()).startsWith(search.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.teacherName != null && (obj.teacherName.toLowerCase()).startsWith(search.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.mobileNum != null && (obj.mobileNum.replace(/[()\-" ]+/g, '').toLowerCase()).startsWith(search.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.parentuser.userName != null && (obj.parentuser.userName.toLowerCase()).startsWith(search.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.pin != null && (obj.pin.toLowerCase()).startsWith(search.toLowerCase())) {
                    searchedSchool.push(obj);
                } /* else if (schoolName != null && (schoolName.toLowerCase()).startsWith(search.toLowerCase())) {
                searchedSchool.push(obj);
            }  */
            });
        } else {
            searchedSchool = schoolFilter
        }
        this.setState({ students: searchedSchool || [], loading: false })

    }
    filterSchool = () => {
        const searchEl = document.getElementById('search');
        let s = searchEl ? searchEl.value : (this.state.search || '');
        //alert(s)
        let filteredData = [];
        const activeTab = document.querySelectorAll(".active")[0];
        let filter = activeTab ? (activeTab.getAttribute("name") || '') : '';
        switch (filter) {
            case 'invited':
                this.state.students.map(item => {
                    item.register ? filteredData.push(item) : '';
                });
                break;
            case 'notInvited':
                this.state.students.map(item => {
                    !item.register ? filteredData.push(item) : '';
                });
                break;
            case 'registered':
                this.state.students.map(item => {
                    item.parentuser.isParentRegistered ? filteredData.push(item) : '';
                });
                break;
            case 'notRegistered':
                this.state.students.map(item => {
                    !item.parentuser.isParentRegistered ? filteredData.push(item) : '';
                });
                break;
            case 'enrollBC&AC':
                this.state.students.map(item => {
                    item.isEnrollBCAndACPkt ? filteredData.push(item) : '';
                });
                break;
            case 'Free':
                this.state.students.map(item => {
                    item.isFreeMealEligible ? filteredData.push(item) : '';
                });
                break;
            case 'Reduced':
                this.state.students.map(item => {
                    item.isReducePriceEligible ? filteredData.push(item) : '';
                });
                break;
            case 'Regular':
                this.state.students.map(item => {
                    (!item.isFreeMealEligible && !item.isReducePriceEligible) ? filteredData.push(item) : '';
                });
                break;
            case 'BC':
                this.state.students.map(item => {
                    (item.beforeCare === true) ? filteredData.push(item) : '';
                });
                this.setState({ data: filteredData });
                break;
            case 'AC':
                this.state.students.map(item => {
                    (item.beforeCare !== true) ? filteredData.push(item) : '';
                });
                this.setState({ data: filteredData });
                break;
            default:
                filteredData = this.state.students;
                break;
        }
        searchedSchool = [];
        if (s.length > 0) {

            filteredData.forEach(obj => {
                if (obj._id != null && (obj._id.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.studentId != null && (obj.studentId.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.firstName != null && (obj.firstName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.lastName != null && (obj.lastName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.teacherName != null && (obj.teacherName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.mobileNum != null && (obj.mobileNum.replace(/[()\-" ]+/g, '').toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.parentuser.userName != null && (obj.parentuser.userName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.pin != null && (obj.pin.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                }
            });
            this.updateState(searchedSchool);
        }
        else {
            document.getElementById("addSchool");
            this.updateState(searchedSchool.length == 0 ? filteredData : searchedSchool);
        }
        this.forceUpdate();
    };
    componentDidMount = () => {
        this.setState({ loading: false });
        this.getEligibilityCodes();
        this.getDataByGrade(0);
        this._notificationSystem = this.refs.notificationSystem;
    };
    handleFirstNameChange = (idx) => (evt) => {
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            return { ...student, firstName: evt.target.value };
        });

        this.setState({ studentsForm: newStudent });
    };
    handleLastNameChange = (idx) => (evt) => {
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            return { ...student, lastName: evt.target.value };
        });

        this.setState({ studentsForm: newStudent });
    };
    handleAddressChange = (idx) => (evt) => {
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            return { ...student, numberStreetApt: evt.target.value };
        });

        this.setState({ studentsForm: newStudent });
    };
    handleZipChange = (idx) => (evt) => {
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            return { ...student, cityStateZip: evt.target.value };
        });

        this.setState({ studentsForm: newStudent });
    };
    handleCardCheckboxChange = (evt, idx) => {

        let studentList = this.state.studentsForm;
        studentList[idx][evt.target.name] = evt.target.checked ? true : false;
        this.setState({ studentsForm: studentList });
    };
    handleIdChange = (idx) => (evt) => {
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            return { ...student, studentId: evt.target.value };
        });

        this.setState({ studentsForm: newStudent });
    };
    handleGradeChange = (idx) => (evt) => {
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            return { ...student, gradeName: evt.target.value };
        });

        this.setState({ studentsForm: newStudent });
    };
    handleTeacherChange = (idx) => (evt) => {
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            return { ...student, teacherName: evt.target.value };
        });
        this.setState({ studentsForm: newStudent });
    };
    handleMailChange = (idx) => (evt) => {
        //
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            var obj = { ...student };
            obj.parentuser.userName = evt.target.value;
            return obj;

        });

        this.setState({ studentsForm: newStudent });
    };
    handleAltMailChange = (idx) => (evt) => {
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            var obj = { ...student };
            obj.parentuser.parentAltEmail = evt.target.value;
            return obj;
        });

        this.setState({ studentsForm: newStudent });
    };
    handleMobileNoChange = (idx) => (evt) => {
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            return { ...student, mobileNo: evt.target.value };//Adding National formatting)
        });
        this.setState({ studentsForm: newStudent });
    }
    handleReducePriceChange = (idx) => (evt) => {

        if (document.getElementById("isReducePriceEligible" + idx).checked) {
            document.getElementById("isFreeMealEligible" + idx).checked = false;
        }

        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            var obj = { ...student };
            obj[evt.target.name] = evt.target.checked;
            obj["isFreeMealEligible"] = false;
            obj['decisionReason'] = '';
            obj['category'] = '';
            return obj;
        });

        this.setState({ studentsForm: newStudent });
    }

    handleFreeMealChange = (idx) => (evt) => {
        if (document.getElementById("isFreeMealEligible" + idx).checked) {
            document.getElementById("isReducePriceEligible" + idx).checked = false;
        }

        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            var obj = { ...student };
            obj[evt.target.name] = evt.target.checked;
            obj["isReducePriceEligible"] = false;
            obj['decisionReason'] = '';
            obj['category'] = '';
            return obj;
        });

        this.setState({ studentsForm: newStudent });
    }


    handleAddStudent = () => {
        this.setState({
            studentsForm: this.state.studentsForm.concat([{
                "loggedUser": "",
                "firstName": '',
                "lastName": '',
                "studentId": '',
                "gradeName": '',
                "mobileNo": '',
                "teacherName": '',
                "decisionReason": '',
                "category": '',
                "isReducePriceEligible": false,
                "isFreeMealEligible": false,
                "defaultNotifyEmail": parentEmailsEnum.both,
                "schoolYear": '',
                "parentuser": {
                    "loggedUser": "",
                    "userName": "",
                    "parentAltEmail": ""
                },
                "numberStreetApt": "",
                "cityStateZip": "",
                hasMilkCard: false,
                beforeCare: false,
                additionalNotes: '',
                actualPrg: ''
            }])
        });
    };
    handleRemoveStudent = (idx) => () => {
        this.setState({
            studentsForm: this.state.studentsForm.filter((s, sidx) => idx !== sidx)
        });
    };
    handleDefaultEmailNotifyChange = (idx) => (evt) => {
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            var obj = { ...student };
            obj.defaultNotifyEmail = evt.target.value;
            return obj;
        });

        this.setState({ studentsForm: newStudent });
    };
    onStudentDataSubmit = (event, callback) => {
        let schoolId = sessionStorage.getItem('SchoolId');
        let loggedUserInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let loggedUser = loggedUserInfo.username;
        let students = [];
        let invalidMobileNos = [];
        this.state.studentsForm.map((student, k) => {
            if (student.mobileNo.length !== 0 && student.mobileNo.length < this.state.mobileLength) {
                invalidMobileNos.push(k);
            }
            students.push({
                "loggedUser": loggedUser,
                "firstName": student.firstName,
                "lastName": student.lastName,
                "gradeName": student.gradeName,
                "studentId": student.studentId,
                "mobileNo": student.mobileNo.length > 0 ? (dial_code() + student.mobileNo) : '',
                "teacherName": student.teacherName,
                "decisionReason": student.decisionReason,
                "category": student.category,
                "isReducePriceEligible": student.isReducePriceEligible,
                "isFreeMealEligible": student.isFreeMealEligible,
                "defaultNotifyEmail": student.defaultNotifyEmail,
                "schoolYear": sessionStorage.getItem('schoolYearValue'),
                "parentuser": {
                    "loggedUser": loggedUser,
                    "userName": student.parentuser.userName,
                    "parentAltEmail": student.parentuser.parentAltEmail
                },
                "numberStreetApt": student.numberStreetApt,
                "cityStateZip": student.cityStateZip,
                hasMilkCard: student.hasMilkCard,
                beforeCare: student.beforeCare,
                additionalNotes: student.additionalNotes,
                actualPrg: student.actualPrg
            });
        });
        if (students[0].isReducePriceEligible && (students[0].category || '') == '') {
            _addNotificationError('Please Select Reduced Eligibility Code.', this);
            callback(true);
            return false;
        }
        if (students[0].isFreeMealEligible && (students[0].category || '') == '') {
            _addNotificationError('Please Select Free Eligibility Code.', this);
            callback(true);
            return false;
        }
        if (students[0].isFreeMealEligible && students[0].category == 'Free (TANF,SNAP,Foster)' && (students[0].actualPrg || '') === '') {
            _addNotificationError('Please Select Free Eligibility Student Specific Program.', this);
            callback(true);
            return false;
        }
        if (invalidMobileNos.length > 0) {
            _addNotificationError('Please Provide valid mobile numbers.', this);
            callback(true);
            event.preventDefault();
            return false;
        } else {
            let headers = {
                'Content-Type': 'application/json'
            };
            if (students.length > 0) {
                postWithHeadersResponse('/students?mealSchoolId=' + schoolId + '&access_token=', JSON.stringify(students), headers).then((response) => {
                    if (response.statusCode !== 200) {
                        throw Error(response.statusMessage);
                    }
                    return response;
                }).then(data => {
                    this.setState({ addModalIsOpen: false });
                    this.setState({
                        studentsForm: [{
                            "firstName": "",
                            "lastName": "",
                            "gradeName": "",
                            "studentId": "",
                            "mobileNo": "",
                            "teacherName": '',
                            "decisionReason": '',
                            "category": '',
                            "isReducePriceEligible": false,
                            "isFreeMealEligible": false,
                            "defaultNotifyEmail": parentEmailsEnum.both,
                            "schoolYear": '',
                            "parentuser": {
                                "loggedUser": "",
                                "userName": "",
                                "parentAltEmail": ""
                            },
                            "numberStreetApt": "",
                            "cityStateZip": "",
                            hasMilkCard: false,
                            beforeCare: false,
                            additionalNotes: '',
                            actualPrg: ''
                        }]
                    });
                    this.getDataByGrade(this.state.tabIndex);
                    _addNotification('Students Added Successfully.', this);
                    callback(true);
                    //alert('Students Added Succesfully');
                }).catch(
                    (error) => {
                        _addNotificationError(error.message, this);
                        callback(true);
                        console.log('Cannot save students', error)
                    }
                );
            }
        }
        event.preventDefault();
    };
    handleChangeEditStudent = (e) => {
        if (e.target.name === 'parentEmailId') {
            this.state.editStudent.parentuser.userName = e.target.value;
        }
        else if (e.target.name === 'parentAltEmail') {
            this.state.editStudent.parentuser.parentAltEmail = e.target.value;
        }
        else {
            this.state.editStudent[e.target.name] = e.target.value;
        }
        this.forceUpdate();
        // this.setState({editStudent: this.state.editStudent});
    };

    handleCardCheckboxEditChange = (e) => {
        let _editStudent = this.state.editStudent;
        _editStudent[e.target.name] = e.target.checked ? true : false;
        this.setState({ editStudent: _editStudent });
    }
    handleDefaultEmailNotifyEditChange = (e) => {
        this.state.editStudent['defaultNotifyEmail'] = e.target.value;
        this.forceUpdate();
    };

    handleEditMobileNo = (e) => {
        this.state.editStudent.mobileNo = e.target.value;
        this.forceUpdate();

    }

    handleTeachersEdit = () => {
        document.getElementById('teacherNameEdit').value = '';
    };

    handleEditReducePrice = (e) => {
        console.log(e.target);
        if (document.getElementById("isReducePriceEligible").checked) {
            document.getElementById("isFreeMealEligible").checked = false;
        }

        this.state.editStudent[e.target.name] = e.target.checked;
        this.state.editStudent["isFreeMealEligible"] = false;
        this.forceUpdate();

    }

    handleEditFreeMeal = (e) => {
        console.log(e.target);
        if (document.getElementById("isFreeMealEligible").checked) {
            document.getElementById("isReducePriceEligible").checked = false;
        }
        this.state.editStudent[e.target.name] = e.target.checked;
        this.state.editStudent["isReducePriceEligible"] = false;

        this.forceUpdate();

    }


    activateStudent(student) {
        let loggedUserInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let loggedUser = loggedUserInfo.username;
        let body = JSON.stringify({
            "isActive": true,
            loggedUser: loggedUser,
            modifiedOn: moment().utc()
        });
        let studentId = student._links.self.href.split('/').pop();
        put('/changeStdStatus/' + studentId + '?isActive=true&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.getDataByGrade(this.state.tabIndex);
            this.getDeletedStudents();
            _addNotification('Successfully restored students data.', this);

        }).catch(
            (error) => {
                _addNotificationError('Unable to Restore ! Try Again.', this);
                console.log('Restore students data response', error)
            }
        );
    }
    exportStudents = () => {
        const _self = this;
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let schoolId = userInfo.schoolId;
        get(`/${schoolId}/studentsExport/${this.state.selectedSchoolYear || sessionStorage.getItem('schoolYearValue')}?access_token=`).then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                return res.blob();
            }
        }).then(blob => {
            let filename = 'Students data';
            download(blob,
                filename + '.xls', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, _self)
                this.setState({ loading: false })
                //console.log('Get Excel File response', error)
            }
        )
    }

    getDeletedStudents() {
        let userInfo = {};
        try {
            userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo')) || {};
        } catch (ex) {
            userInfo = {};
        }
        let schoolId = userInfo.schoolId;
        get('/studentUsers/search/findByIsActiveAndMealSchoolSchoolIdAndSchoolYear?isActive=false&schoolId=' + schoolId + '&schoolYear=' + (this.state.selectedSchoolYear || sessionStorage.getItem('schoolYearValue')) + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.setState({
                deletedStudents: data._embedded.studentUsers,
            })
        }).catch(
            (error) => {
                console.log('Get deleted students data response', error)
            }
        );
    }

    handleClick() {
        this.getDeletedStudents();
        this.setState({
            show: !this.state.show
        })

    }

    openModal(stateObj, col) {
        if (stateObj === "deleteModalIsOpen") {
            let data = col;
            this.setState({ editStudent: data });
        }
        else if (stateObj === "editModalIsOpen") {
            //alert('came here')
            console.log('data of edit', col);
            let mobileNo = col.mobileNo || '';
            mobileNo = mobileNo.substr(-this.state.mobileLength);
            let data = JSON.parse(JSON.stringify(col));
            data.defaultNotifyEmail = data.defaultNotifyEmail || parentEmailsEnum.both;
            data.parentuser.parentAltEmail = ((data.parentuser.parentAltEmail == 'N/A' || data.parentuser.parentAltEmail == 'NA') ? undefined : data.parentuser.parentAltEmail)
            data.mobileNo = mobileNo;
            data.image = (data.image || '') === '' ? defaultImg : data.image;
            console.log('data of edit', data);
            this.setState({ editStudent: data });
        }
        this.setState({ [stateObj]: true });
    }

    afterOpenModal() {
    }

    closeModal(stateObj) {
        this.setState({ [stateObj]: false });
        this.setState({
            studentsForm: [{
                "loggedUser": "",
                "firstName": '',
                "lastName": '',
                "studentId": '',
                "gradeName": '',
                "mobileNo": "",
                "teacherName": '',
                "decisionReason": '',
                "category": '',
                "isReducePriceEligible": false,
                "isFreeMealEligible": false,
                "defaultNotifyEmail": parentEmailsEnum.both,
                "schoolYear": '',
                "parentuser": {
                    "loggedUser": "",
                    "userName": "",
                    "parentAltEmail": ""
                },
                "numberStreetApt": "",
                "cityStateZip": "",
                hasMilkCard: false,
                beforeCare: false,
                additionalNotes: '',
                actualPrg: ''
            }]
        });
        this.getDataByGrade(this.state.tabIndex);
        // console.log('change', this.state.editStudent);
    }

    filterStudents(e) {
        this.state.currentGrade = e.target.value;
        this.getSchoolData();
    }

    updateState(newState) {
        if (newState.length === 0) {
            document.getElementById("addSchool");
        } else {
            document.getElementById("addSchool");
        }
        this.setState({ data: newState });
    }


    deleteStudent(e, callback) {
        const _self = this;
        let recId = this.state.editStudent._links.self.href.split('/').pop();
        let headers = {
            'Content-Type': 'application/json'
        };

        let loggedUserInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let loggedUser = loggedUserInfo.username;
        let body = JSON.stringify({
            "isActive": false,
            loggedUser: loggedUser,
            modifiedOn: moment().utc()
        });
        putWithHeadersResponse('/changeStdStatus/' + recId + '?isActive=false&access_token=', undefined, headers).then((response) => {
            if (!response.ok) {
                throw response.text();
            }
            return response.json();
        }).then(data => {
            _addNotification(data.statusMessage, this);
            this.setState({ deleteModalIsOpen: false })
            callback(true);
            this.getDataByGrade(this.state.tabIndex);

        }).catch(err => {
            err.then(error => {
                _addNotificationError(JSON.parse(error).statusMessage, _self);
                callback(true);
                _self.setState({ deleteModalIsOpen: false })
            })
        });
    }

    getColumns(data) {
        console.log('data for get cols', data);
        let columns = [];
        let header = ['First Name', 'Last Name', 'Pin', 'School', 'Parent EmailId', 'Parent MobileNo', 'Actions'];
        if (data.length === 0) {

            header.map(key =>
                columns.push({ Header: key }));

        }
        else {
            columns.push({
                accessor: 'firstName',
                id: "firstName",
                Header: 'First Name',
                sortable: true,
                style: { textAlign: 'center' }
            });
            columns.push({
                accessor: 'lastName',
                id: "lastName",
                Header: 'Last Name',
                sortable: true,
                style: { textAlign: 'center' }
            });

            columns.push({
                accessor: 'studentId',
                Header: 'Student Id',
                Cell: props => <span>{props.original.studentId}</span>,
                style: { textAlign: 'center' }
            })
            columns.push({
                accessor: 'pin',
                Header: 'Pin',
                style: { textAlign: 'center' }
            });
            columns.push({
                accessor: 'mSchoolId',
                Header: 'School',
                Cell: props => {
                    const { schoolObj } = this.state;
                    const schoolName = ((schoolObj[props.original.mSchoolId] || [])[0] || {}).schoolName || ''
                    return <span>{schoolName}</span>
                },
                style: { textAlign: 'center' }
            })
            if (getAccessLevelByModule(modEnum.MKA)) {
                columns.push({
                    accessor: 'allergies',
                    Header: 'Allergies',
                    style: { textAlign: 'center', verticalAlign: 'middle' },
                    Cell: (props) => (
                        <Fragment>
                            <a className="btn-linkedin-link" style={{ padding: '0px', cursor: 'pointer' }}
                                data-tip data-for={'std-' + props.index}>
                                {props.value}</a>
                            <ReactTooltip id={'std-' + props.index} aria-haspopup='true' type="dark" effect="float">
                                <div>
                                    {props.value}
                                </div>
                            </ReactTooltip>
                        </Fragment>
                    )
                });
            }
            columns.push({
                accessor: 'parentuser.userName',
                Header: 'PARENT EMAILID',
                style: { textAlign: 'center' }
            });
            columns.push({
                accessor: 'mobileNum', // formatted mobile num for display
                Header: 'PARENT MOBILENO',
                style: { textAlign: 'center' }
            });


            columns.push({
                id: 'actionButton',
                accessor: "studentId",
                Header: 'ACTIONS',
                style: { textAlign: 'center' }, // className: "actions text-center"
                width: 120,
                Cell: ({ row }) => (<div>
                    <a title="Edit student info" onClick={() => {
                        this.openModal("editModalIsOpen", row._original);
                        this.setState({ lookupStatus: "true" }, () => {
                            this.props.changeShowHideSchoolFitler(false);
                        })
                    }}><i
                            className="fa fa-eye tbl-rounded-icon bg-color-1 fa-icon" /></a>


                </div>),
            });

        }
        return columns;
    }




    getDataByGrade(gradeName) {
        let teachers = [];
        let studentsByGrade = [];
        this.setState({ loading: true });
        let schoolId = sessionStorage.getItem('SchoolId');
        const districtID = sessionStorage.getItem('districtId');
        const schoolYear = this.state.selectedSchoolYear || getActiveSchoolYear();
        const userName = this.state.userInfo.username;
        //let selectedFilter = document.getElementById('selector').querySelectorAll(".active")[0].getAttribute("name") || '';
        (get(`/studentUsers/search/findByMealSchoolDistrictIdAndSchoolYearAndIsActive?distId=${districtID}&schoolYear=${schoolYear}&isActive=true&access_token=`))
            .then((response) => {
                console.log("API CALL RUN");
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                console.log("allStudentData", this.state.allStudentData);
                console.log('data', data);
                const stData = data['_embedded']['studentUsers'];
                this.setState({ studentsCount: stData.length, accountHistoryData: stData, students: stData });
                console.log('stData', stData);
                console.log('student data', stData);
                const gradesGroup = groupBy(getSchoolGrades(), 'value');
                if ((gradeName || '0') == '0') {
                    return stData.map(item => {
                        localStorage.setItem('SchoolId', item.mSchoolId);
                        let _id = item.studentId;
                        item.fullName = item.lastName + ', ' + item.firstName;
                        item.grade = ((gradesGroup[item.gradeName] || [])[0] || {}).label || '';
                        teachers.push(item.teacherName);
                        let mobileNum = item.mobileNo || ''
                        return {
                            _id,
                            mobileNum,
                            ...item
                        };
                    });

                }
                else {
                    stData.map(item => { //pushes all students for grade selected into an array
                        localStorage.setItem('SchoolId', item.mSchoolId);
                        let _gradeName = item.gradeName;

                        if (_gradeName === gradeName) {
                            item.grade = ((gradesGroup[item.gradeName] || [])[0] || {}).label || '';
                            studentsByGrade.push(item);
                        }
                    });
                    return studentsByGrade.map(item => {
                        localStorage.setItem('SchoolId', item.mSchoolId);
                        let _id = item.studentId;
                        item.fullName = item.lastName + ', ' + item.firstName
                        teachers.push(item.teacherName);
                        let mobileNum = item.mobileNo || '';
                        return {
                            _id,
                            mobileNum,
                            ...item
                        };
                    });

                }
                this.filterSchool();
            }).then(data => {
                console.log("Students by grade ", studentsByGrade);
                this.setState({ studentsCount: studentsByGrade.length });
                console.log('Successfully got school data', data);
                let columns = this.getColumns(data);
                if (gradeName === 0) {
                    teacherNames = [...new Set(teachers)]
                }
                console.log('teacherNames', teacherNames);
                this.setState({
                    students: data,
                    data: data,
                    columns: columns,
                    loading: false,
                    studentCount: data.length
                })
                this.filterSchool();
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    console.log('Get School data response', error)

                }
            );

    }
    changeB_ACare = (isBeforeCare, callback) => {
        let selectedRows = this.state.selection;
        this.setState({ loading: true });
        let data = {};
        let schoolId = sessionStorage.getItem('SchoolId');
        if (this.state.selectAll && this.state.tabIndex === 0 && this.state.studentCount === (this.state.selection).length) {
            data = {
                "schoolId": schoolId,
                "schoolYear": sessionStorage.getItem('schoolYearValue'),
                "isFreeLunch": null,
                "isBeforeCare": isBeforeCare
            };
        }
        else if (this.state.selectAll && this.state.tabIndex !== 0 && this.state.studentCount === (this.state.selection).length) {
            data = {
                "schoolId": schoolId,
                "schoolYear": sessionStorage.getItem('schoolYearValue'),
                "gradeName": this.state.tabIndex,
                "isFreeLunch": null,
                "isBeforeCare": isBeforeCare
            };
        } else {
            selectedRows = this.state.selection;
            if (selectedRows.length !== 0) {
                data = {
                    "schoolId": schoolId,
                    "schoolYear": sessionStorage.getItem('schoolYearValue'),
                    "isFreeLunch": null,
                    "isBeforeCare": isBeforeCare,
                    "studentIds": selectedRows
                }
            } else {
                _addNotificationError('Please select atleast one student.', this);
                this.setState({ loading: false });
                callback(true);
                return false;
            }
        }
        let headers = {
            'Content-Type': 'application/json'
        };
        postWithHeaders('/freeReducedLunchEligUpdate?access_token=', JSON.stringify(data), headers).then((response) => {
            if (response.status === 200) {

                this.setState({ loading: false, selection: [], selectionStuList: {}, selectAll: false });
                let _message = isBeforeCare ? 'Successfully updated before care status.' : 'Successfully updated after care status.'
                _addNotification(_message, this);
                callback(true);
                this.getDataByGrade(this.state.tabIndex);
            } else if (!response.ok) {
                throw Error(response.statusText);
            }
        }).catch(
            (error) => {
                this.setState({ loading: false })
                _addNotificationError('Failed to send link ! Try again.', this);
                callback(true);
                console.log('Send Notification Error', error)
            }
        );

    }
    changeFreeOrRedPrice(isFreeLunch, callback) {
        let selectedRows = this.state.selection;
        this.setState({ loading: true });
        let data = {};
        let schoolId = sessionStorage.getItem('SchoolId');
        if (this.state.selectAll && this.state.tabIndex === 0 && this.state.studentCount === (this.state.selection).length) {
            data = {
                "schoolId": schoolId,
                "schoolYear": sessionStorage.getItem('schoolYearValue'),
                "isFreeLunch": isFreeLunch
            };
        }
        else if (this.state.selectAll && this.state.tabIndex !== 0 && this.state.studentCount === (this.state.selection).length) {
            data = {
                "schoolId": schoolId,
                "schoolYear": sessionStorage.getItem('schoolYearValue'),
                "gradeName": this.state.tabIndex,
                "isFreeLunch": isFreeLunch
            };
        } else {
            selectedRows = this.state.selection;
            if (selectedRows.length !== 0) {
                data = {
                    "schoolId": schoolId,
                    "schoolYear": sessionStorage.getItem('schoolYearValue'),
                    "isFreeLunch": isFreeLunch,
                    "studentIds": selectedRows
                }
            } else {
                _addNotificationError('Please select atleast one student.', this);
                this.setState({ loading: false });
                callback(true);
                return false;
            }
        }
        let headers = {
            'Content-Type': 'application/json'
        };
        postWithHeaders('/freeReducedLunchEligUpdate?access_token=', JSON.stringify(data), headers).then((response) => {
            if (response.status === 200) {
                this.setState({ loading: false, selection: [], selectionStuList: {}, selectAll: false });
                let _message = isFreeLunch ? 'Succesfully updated free lunch eligibility status.' : 'Succesfully updated reduced price lunch eligibility status.'
                _addNotification(_message, this);
                callback(true);
                this.getDataByGrade(this.state.tabIndex);
            } else if (!response.ok) {
                throw Error(response.statusText);
            }
        }).catch(
            (error) => {
                this.setState({ loading: false })
                _addNotificationError('Failed to send link ! Try again.', this);
                callback(true);
                console.log('Send Notification Error', error)
            }
        );
    }

    sendNotification(action, row, callback) {
        console.log("sendNotification RUN");
        this.setState({ loading: true })
        let selectedRows = [];
        let data = {};
        let schoolId = sessionStorage.getItem('SchoolId');
        if (action === 'single') {
            selectedRows = [row.studentId];
            data = {
                "schoolId": schoolId,
                "notificationType": "Registration",
                "studentIds": selectedRows,
                "sendStatus": "true",
                "schoolYear": sessionStorage.getItem('schoolYearValue')
            }
        }
        else if (action === 'multiple') {
            if (this.state.selectAll && this.state.tabIndex === 0 && this.state.studentCount === (this.state.selection).length) {
                data = {
                    "schoolId": schoolId,
                    "notificationType": "Registration",
                    "sendStatus": "true",
                    "schoolYear": sessionStorage.getItem('schoolYearValue')
                }
            }
            else if (this.state.selectAll && this.state.tabIndex !== 0 && this.state.studentCount === (this.state.selection).length) {
                data = {
                    "schoolId": schoolId,
                    "notificationType": "Registration",
                    "gradeName": this.state.tabIndex,
                    "schoolYear": sessionStorage.getItem('schoolYearValue'),
                    "sendStatus": "true"
                }
            }
            else {
                selectedRows = this.state.selection;
                if (selectedRows.length !== 0) {
                    data = {
                        "schoolId": schoolId,
                        "notificationType": "Registration",
                        "studentIds": selectedRows,
                        "schoolYear": sessionStorage.getItem('schoolYearValue'),
                        "sendStatus": "true"
                    }
                } else {
                    _addNotificationError('Please select students to send link.', this);
                    callback(true);
                }
            }
        }
        let headers = {
            'Content-Type': 'application/json'
        };

        postWithHeaders('/sendNotificationParents?access_token=', JSON.stringify(data), headers).then((response) => {
            if (response.status === 200) {
                this.setState({ loading: false })
                _addNotification('Registration invite has been successfully sent!!', this);
                callback(true);
                this.getDataByGrade(this.state.tabIndex);
            } else if (!response.ok) {
                throw Error(response.statusText);
            }
        }).catch(
            (error) => {
                this.setState({ loading: false });
                _addNotificationError('Failed to send link ! Try again.', this);
                callback(true);
                console.log('Send Notification Error', error)
            }
        );
    }

    onUpdateStudentSubmit(event, callback) {
        event.preventDefault();
        console.log('edit student', this.state.editStudent);
        if (this.state.editStudent.mobileNo.length !== 0 && this.state.editStudent.mobileNo.length < this.state.mobileLength) {
            _addNotificationError('Please Provide valid mobile number.', this);
            callback(true);
            return false;
        }
        if (this.state.editStudent.isReducePriceEligible && (this.state.editStudent.category || '') == '') {
            _addNotificationError('Please Select Reduced Eligibility Code.', this);
            callback(true);
            return false;
        }
        if (this.state.editStudent.isFreeMealEligible && (this.state.editStudent.category || '') == '') {
            _addNotificationError('Please Select Free Eligibility Code.', this);
            callback(true);
            return false;
        }
        if (this.state.editStudent.isFreeMealEligible && this.state.editStudent.category == 'Free (TANF,SNAP,Foster)' && (this.state.editStudent.actualPrg || '') === '') {
            _addNotificationError('Please Select Free Eligibility Student Specific Program.', this);
            callback(true);
            return false;
        }
        let allowed = [
            'firstName',
            'lastName',
            'studentId',
            'gradeName',
            'teacherName',
            "schoolYear",
            'parentuser',
            'mobileNo',
            'isReducePriceEligible',
            'isFreeMealEligible',
            'numberStreetApt',
            'cityStateZip',
            'hasMilkCard',
            'beforeCare',
            'isEnrollBCAndACPkt',
            'defaultNotifyEmail',
            "decisionReason",
            "category",
            "additionalNotes",
            "actualPrg",
            "freezePreOrder"
        ];
        let filtered = Object.keys(this.state.editStudent)
            .filter(key => allowed.includes(key))
            .reduce((obj, key) => {
                obj[key] = this.state.editStudent[key];
                obj["loggedUser"] = sessionStorage.getItem('loggedUserName');
                return obj;
            }, {});
        filtered.mobileNo = (filtered.mobileNo.trim().length > 0 ? ((dial_code() + filtered.mobileNo.substr(-this.state.mobileLength))) : '');
        let recId = this.state.editStudent._links.self.href.split("/").pop();
        let headers = {
            "Content-Type": "application/json"
        };

        postWithHeadersResponse('/studentUpdate?studentRecId=' + recId + '&access_token=', JSON.stringify(filtered), headers).then(response => {
            console.log('response', response)
            if (response.statusCode == 200) {
                // alert('student data updated')
                _addNotification('Successfully updated student data.', this);
                callback(true);
                this.closeModal("editModalIsOpen");
            }
            else {
                throw Error(response.statusMessage);
            }
        }).catch(error => {
            // this.closeModal("editModalIsOpen");
            console.log('Error while updating', error)
            _addNotificationError(error.message, this);
            callback(true);
        });
    }

    getFilteredData = (grade, filter) => {

        let filteredData = [];
        switch (filter) {
            case 'invited':
                this.state.students.map(item => {
                    item.register ? filteredData.push(item) : '';
                });

                this.setState({ data: filteredData });
                console.log('invited', JSON.stringify(filteredData, null, 2));
                break;
            case 'notInvited':
                this.state.students.map(item => {
                    !item.register ? filteredData.push(item) : '';
                });

                this.setState({ data: filteredData });
                console.log('not invited', JSON.stringify(filteredData, null, 2));
                break;
            case 'registered':
                this.state.students.map(item => {
                    item.parentuser.isParentRegistered ? filteredData.push(item) : '';
                });
                this.setState({ data: filteredData });
                console.log('registered', JSON.stringify(filteredData, null, 2));
                break;
            case 'notRegistered':
                this.state.students.map(item => {
                    !item.parentuser.isParentRegistered ? filteredData.push(item) : '';
                });
                this.setState({ data: filteredData });
                console.log('not registered', JSON.stringify(filteredData, null, 2));
                break;
            case 'enrollBC&AC':
                this.state.students.map(item => {
                    item.isEnrollBCAndACPkt ? filteredData.push(item) : '';
                });
                this.setState({ data: filteredData });
                console.log('not registered', JSON.stringify(filteredData, null, 2));
                break;
            case 'Free':
                this.state.students.map(item => {
                    item.isFreeMealEligible ? filteredData.push(item) : '';
                });
                this.setState({ data: filteredData });
                break;
            case 'Reduced':
                this.state.students.map(item => {
                    item.isReducePriceEligible ? filteredData.push(item) : '';
                });
                this.setState({ data: filteredData });
                break;
            case 'Regular':
                this.state.students.map(item => {
                    (!item.isFreeMealEligible && !item.isReducePriceEligible) ? filteredData.push(item) : '';
                });
                this.setState({ data: filteredData });
                break;
            case 'BC':
                this.state.students.map(item => {
                    (item.beforeCare === true) ? filteredData.push(item) : '';
                });
                this.setState({ data: filteredData });
                break;
            case 'AC':
                this.state.students.map(item => {
                    (item.beforeCare !== true) ? filteredData.push(item) : '';
                });
                this.setState({ data: filteredData });
                break;
        }
    };
    toggleSelection = (key, shift, row) => {
        //alert('selection')
        // alert(key)
        let selection = [...this.state.selection];
        let selectionStuList = this.state.selectionStuList
        const keyIndex = selection.indexOf(key);
        // check to see if the key exists
        if (keyIndex >= 0) {
            // it does exist so we will remove it using destructing
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
            delete selectionStuList[key];
        } else {
            // it does not exist so add it
            selection.push(key);
            selectionStuList[key] = { name: row.firstName + ' ' + row.lastName, id: row._links.self.href.split("/").pop() }
        }
        // update the state
        this.setState({ selectAll: false, selection: selection, selectionStuList: selectionStuList });
    };
    toggleAll = () => {
        //alert('toggleAll')
        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        let selectionStuList = {}
        if (selectAll) {
            // we need to get at the internals of ReactTable
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            // the 'sortedData' property contains the currently accessible records based on the filter and sort
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            //this.setState({studentCount: currentRecords.length});
            // we just push all the IDs onto the selection array
            //console.log(JSON.stringify(currentRecords,null,2))
            currentRecords.forEach(item => {
                selection.push(item._original._id);
                selectionStuList[item._original._id] = { name: item._original.firstName + ' ' + item._original.lastName, id: item._original._links.self.href.split("/").pop() }
            });
        }
        this.setState({ selectAll, selection, selectionStuList });
    };
    isSelected = key => {
        const res = (this.state.selection || []).find((item) => {
            const _item = ((item || '') + '').replace('select-', '');
            return _item == key;
        });
        if (res) {
            return true;
        } else {
            return false;
        }
    };
    logSelection = () => {
        console.log("selection:", this.state.selection);
    };
    buildDataFormatForExport = () => {
        // console.log("DATA", this.props.data)
        return (
            [{
                columns: [{ title: 'NAME' }, { title: 'GRADE' }, { title: 'ALLERGIES' },
                { title: 'MOBILE' }, { title: 'STUDENT ID' }, { title: 'PARENT' }
                    , { title: 'HAS MILK CARD' }, { title: 'REDUCED PRICE ELIGIBLE' }, { title: 'FREE MEAL ELIGIBLE' },
                { title: 'ENROLL BC&AC PACK' }, { title: 'BC/AC' }],
                data: this.state.data.map(item => {
                    return [{ value: item.fullName || '' }, { value: item.gradeName || '' }, { value: item.allergies || '' }
                        , { value: item.mobileNo || '' }, { value: item.studentId || '' }, { value: item.parentuser.userName || '' }
                        , { value: item.hasMilkCard || '' }, { value: item.isReducePriceEligible || '' }, { value: item.isFreeMealEligible || '' }
                        , { value: item.isEnrollBCAndACPkt || '' }, { value: item.beforeCare ? 'BC' : 'AC' }]
                })
            }]
        )
    }
    generatePinByGrade() {
        let schoolId = sessionStorage.getItem('SchoolId');
        let grade = this.state.tabIndex;
        put(`/${schoolId}/generateStudentsPIN?grade=${grade}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            _addNotification('Successfully Generated Pin.', this);
            this.setState({ loading: false });
            this.getDataByGrade(grade);
        }).catch(
            (error) => {
                _addNotificationError('Unable to Generate Pin ! Try Again.', this);
                console.log('Generate Pin data response', error)
            }
        );
    }
    downloadExcel = (type) => {
        const _self = this;
        const districtID = sessionStorage.getItem('districtId');
        const schoolYear = this.state.selectedSchoolYear || getActiveSchoolYear();
        let url = `/${districtID}/districtStudentsExport/${schoolYear}?access_token=`;
        if (type == 'ALL') {
            url = `/${districtID}/districtStudentsExport/${schoolYear}?includeInActive=true&access_token=`
        }
        get(url).then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                return res.blob();
            }
        }).then(blob => {
            this.setState({ loading: false })
            let filename = type == 'ALL' ? `Allstudents` : 'ActiveStudents';
            download(blob,
                filename + '.xls', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, _self)
                this.setState({ loading: false })
                //console.log('Get Excel File response', error)
            }
        )

    }
    render() {
        gradeList = getSchoolGrades();
        const { toggleSelection, toggleAll, isSelected } = this;
        const { data, selectAll } = this.state;

        const checkboxProps = {
            selectAll,
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",

            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };

        {
            $('#selector button').click(function () {
                $(this).addClass('active').siblings().removeClass('active');
                // TODO: insert whatever you want to do with $(this) here
            })
        }
        const { search, students } = this.state;
        const currency_symbol = this.state.userInfo.currencySymbol;
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <section className=" full-width clearfix">
                    <div className="container">
                        <div className='sweet-loading'
                            style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                            <BeatLoader
                                size={20}
                                color={'#ea7066'}
                                loading={this.state.loading}
                            />
                        </div>


                        <div className="row">
                            {this.state.lookupStatus === "true" &&

                                (

                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="col-md-6">
                                                <div className="sectionTitle">
                                                    <h2>
                                                        <span>Student Details</span>
                                                    </h2></div></div>
                                            <div className="col-md-6">
                                                <button type="button" className="pull-right btn bg-color-4"
                                                    onClick={() => {
                                                        this.closeModal('editModalIsOpen');
                                                        this.setState({ lookupStatus: "false" }, () => {
                                                            this.props.changeShowHideSchoolFitler(false);
                                                        })
                                                    }}
                                                    style={{ fontSize: 14 }}><i
                                                        class="fa fa-arrow-circle-left" aria-hidden="true"
                                                        style={{ marginRight: 0, paddingLeft: 0 }}></i> Back
                                                </button></div>
                                        </div>
                                        <div className="col-xs-2 col-sm-2 col-md-2">
                                            <div className="form-group">
                                                <div className="media courseList">
                                                    <a className="media-left" style={{ width: '100px', height: '100px', margin: '15px', marginLeft: '21%' }}>
                                                        <img className="media-object" style={{ width: '100px', height: '100px' }}
                                                            src={this.state.editStudent.image}
                                                            alt="Student image" />
                                                    </a>
                                                </div>

                                            </div>
                                            <div className="panel panel-primary">
                                                <div className="panel-body">
                                                    <div className="form-group">
                                                        <div><label style={{ color: 'rgb(234, 112, 102)' }} htmlFor={`acctBalance`}>Meal Account Balance:</label> <span style={{ marginLeft: '5px' }}>{currency_symbol}{this.state.editStudent.accBalance} </span></div>
                                                        <div><label style={{ color: 'rgb(234, 112, 102)' }} htmlFor={`Pin`}>POS Pin:</label><span style={{ marginLeft: '5px' }}>{this.state.editStudent.pin} </span></div>
                                                        <div> <label style={{ color: 'rgb(234, 112, 102)' }} htmlFor={`Eligible`}>Meal Eligibility:</label><span style={{ marginLeft: '5px' }}>{this.state.editStudent.isFreeMealEligible ? 'Free Lunch' : this.state.editStudent.isReducePriceEligible ? 'Reduced Price' : 'Regular Price'}</span></div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-xs-10 col-sm-10 col-md-10">
                                            <form name="editStudents" className="" >
                                                <div className="form-group">
                                                    <div className="col-xs-8 col-sm-8 col-md-8">
                                                        <div className="panel panel-primary">
                                                            <div className="panel-body">
                                                                <div className="row top-buffer col-xs-12">
                                                                    <div className="col-xs-6">
                                                                        <p><span style={{ fontFamily: 'Dosis, sans-serif', color: 'rgb(234, 112, 102)', marginLeft: '26%', fontSize: 'large', fontWeight: 'bold' }}>Student Information</span></p></div>
                                                                    <div className="col-xs-6">
                                                                        <p><span style={{ fontFamily: 'Dosis, sans-serif', color: 'rgb(234, 112, 102)', marginLeft: '43%', fontSize: 'large', fontWeight: 'bold' }}>Parent Information</span></p>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-xs-3">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`First Name`}>First Name</label>
                                                                            <input id={`First Name`}
                                                                                type="text" className="form-control" name="firstName" readOnly='true'
                                                                                placeholder={`Student First Name`}
                                                                                value={this.state.editStudent.firstName}
                                                                                style={{ marginRight: '20px' }}
                                                                                //onChange={e => this.handleChangeEditStudent(e)}
                                                                                required />
                                                                        </div>
                                                                    </div>


                                                                    <div className="col-xs-4 ">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`altEmail`}>Street, Apt.</label>
                                                                            <input type="text" className="form-control"
                                                                                placeholder={`Student- Street, Apt`}
                                                                                name="numberStreetApt" readOnly='true'
                                                                                value={this.state.editStudent.numberStreetApt} style={{ marginRight: '20px' }}
                                                                            //onChange={e => this.handleChangeEditStudent(e)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-xs-1" style={{ width: 'auto' }}>
                                                                        <span class="divider" />
                                                                    </div>
                                                                    <div className="col-xs-4">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`parentEmail`}>Parent Email</label>
                                                                            <input id="parentEmail"
                                                                                type={this.state.editStudent.parentuser.userName == 'NA' ? "text" : "email"}
                                                                                pattern={this.state.editStudent.parentuser.userName == 'NA' ? null : "[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"}
                                                                                className="form-control"
                                                                                name="parentEmailId"
                                                                                placeholder={`Parent E-mail Id`}
                                                                                value={this.state.editStudent.parentuser.userName}
                                                                                readOnly='true'
                                                                                //onChange={e => this.handleChangeEditStudent(e)}
                                                                                required />
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                <div className="row ">
                                                                    <div className="col-xs-3">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`Last Name`}>Last Name</label>
                                                                            <input id={'Last Name'}
                                                                                type="text" className="form-control" name="lastName"
                                                                                placeholder={`Student Last Name`}
                                                                                value={this.state.editStudent.lastName}
                                                                                style={{ marginRight: '20px' }}
                                                                                readOnly='true'
                                                                                //onChange={e => this.handleChangeEditStudent(e)}
                                                                                required />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-xs-4">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`altEmail`}>City, State, Zip.</label>
                                                                            <input type="text" className="form-control"
                                                                                placeholder={`Student- City, State, Zip`}
                                                                                name="cityStateZip"
                                                                                value={this.state.editStudent.cityStateZip} style={{ marginRight: '20px' }}
                                                                                readOnly='true'
                                                                            //onChange={e => this.handleChangeEditStudent(e)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-xs-1" style={{ width: 'auto' }}>
                                                                        <span class="divider" />
                                                                    </div>
                                                                    <div className="col-xs-4">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`altEmail`}>Alt. Email</label>
                                                                            <input id="altEmail"
                                                                                type="email"
                                                                                pattern="[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
                                                                                className="form-control"
                                                                                name="parentAltEmail"
                                                                                placeholder={`Parent Alternate E-Mail Id(Optional)`}
                                                                                value={this.state.editStudent.parentuser.parentAltEmail}
                                                                                readOnly='true'
                                                                            //onChange={e => this.handleChangeEditStudent(e)}
                                                                            />
                                                                        </div></div>

                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-xs-3">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`studentId`}>Student Id</label>
                                                                            <input id={`studentId`}
                                                                                type="text" className="form-control" name="studentId"
                                                                                placeholder={`Student ID`}
                                                                                value={this.state.editStudent.studentId}
                                                                                style={{ marginRight: '20px' }}
                                                                                readOnly='true'
                                                                                //onChange={e => this.handleChangeEditStudent(e)}
                                                                                required />
                                                                        </div></div>

                                                                    <div className="col-xs-4">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`teacherNameEdit`}>Teacher</label>

                                                                            <input
                                                                                className="form-control"
                                                                                list='teachers'
                                                                                id='teacherNameEdit'
                                                                                value={this.state.editStudent.teacherName}
                                                                                onFocus={this.handleTeachersEdit}
                                                                                style={{ marginRight: '20px' }}
                                                                                name="teacherName"
                                                                                placeholder='Teacher Name' autoComplete='off'
                                                                                readOnly='true'
                                                                                //onChange={e => this.handleChangeEditStudent(e)}
                                                                                required />
                                                                            <dataList id="teachers">
                                                                                {teacherNames.map(function (key) {
                                                                                    return <option
                                                                                        value={key}>{key}</option>
                                                                                }, this)}
                                                                            </dataList>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-xs-1" style={{ width: 'auto' }}>
                                                                        <span class="divider" />
                                                                    </div>
                                                                    <div className="col-xs-4">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`mobileNoEdit`}>Mobile</label>
                                                                            <input type="text"
                                                                                className="form-control"
                                                                                id="mobileNoEdit"
                                                                                placeholder={'Mobile Number'}
                                                                                value={this.state.editStudent.mobileNo}
                                                                                readOnly='true'
                                                                                //onChange={value => this.handleEditMobileNo(value)}
                                                                                maxLength={this.state.mobileLength}
                                                                                onKeyPress={numberOnly} />
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                <div className="row">
                                                                    <div className="col-xs-3">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`grade`}>Grade</label>
                                                                            <input id={`grade`}
                                                                                className="form-control"
                                                                                value={this.state.editStudent.gradeName}
                                                                                style={{ marginRight: '20px' }}
                                                                                name="gradeName"
                                                                                readOnly='true'
                                                                                //onChange={e => this.handleChangeEditStudent(e)}
                                                                                required />
                                                                            {/*  <option disabled selected value>Grade</option>
                                                                            {getSchoolGrades(0, false).map((item) => {
                                                                                return <option
                                                                                    value={item.value}>{item.label}</option>
                                                                            }, this)} */}

                                                                        </div>
                                                                    </div>
                                                                    <div className="col-xs-4"></div>
                                                                    <div className="col-xs-1" style={{ width: 'auto' }}>
                                                                        <span class="divider" />
                                                                    </div>
                                                                    <div className="col-xs-4">
                                                                        <div className="form-group">
                                                                            <label htmlFor={`defNotify`}>Email preference</label>
                                                                            <input className="form-control" id='defNotify' value={this.state.editStudent.defaultNotifyEmail}
                                                                                style={{ marginRight: '20px' }}
                                                                                readOnly='true'
                                                                                //onChange={(e) => this.handleDefaultEmailNotifyEditChange(e)}
                                                                                required />


                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className="row">
                                                            <div className="col-xs-12">
                                                                <div className="form-group">
                                                                    <label htmlFor={'editadditionalNotes'}>Additional Notes</label>
                                                                    <textarea id="editadditionalNotes" className="form-control"
                                                                        value={this.state.editStudent.additionalNotes}
                                                                        readOnly='true'
                                                                   /*  onChange={(e) => {
                                                                        const obj = { ...this.state.editStudent }
                                                                        obj.additionalNotes = e.target.value;
                                                                        this.setState({ editStudent: obj });
                                                                    }} */>

                                                                    </textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-4 col-sm-4 col-md-4">
                                                        <div className="panel panel-primary">
                                                            <div className="panel-body">
                                                                <div className="row top-buffer col-xs-12">

                                                                    <p><span style={{ fontFamily: 'Dosis, sans-serif', color: 'rgb(234, 112, 102)', marginLeft: '29%', fontSize: 'large', fontWeight: 'bold' }}>Account Settings</span></p>

                                                                </div>
                                                                <div className="row">
                                                                    {
                                                                        getAccessLevelByModule(modEnum.LETM) ?
                                                                            <Fragment>
                                                                                <div className="col-xs-12" style={{ marginTop: '8px' }}>
                                                                                    <label style={{ marginRight: 5 }}>Eligible for: </label><br />

                                                                                    <span style={{ margin: 10 }}><input style={eligibleCheck}
                                                                                        readOnly='true'
                                                                                        type="checkbox"
                                                                                        name="isReducePriceEligible"
                                                                                        id={"isReducePriceEligible"}
                                                                                        className="chb"
                                                                                        checked={this.state.editStudent.isReducePriceEligible}
                                                                                    //onChange={e => this.handleEditReducePrice(e)} 
                                                                                    />Reduced Price</span>

                                                                                    <span className="" style={{ margin: 10 }}><input
                                                                                        style={eligibleCheck} type="checkbox"
                                                                                        name="isFreeMealEligible" id={"isFreeMealEligible"}
                                                                                        className="chb"
                                                                                        checked={this.state.editStudent.isFreeMealEligible}
                                                                                        readOnly='true'
                                                                                    //onChange={e => this.handleEditFreeMeal(e)} 
                                                                                    />Free Lunch</span>
                                                                                </div><br></br>
                                                                                {
                                                                                    (this.state.editStudent.isReducePriceEligible == true || this.state.editStudent.isFreeMealEligible == true) ?
                                                                                        <Fragment>
                                                                                            <div className="col-xs-12">
                                                                                                <div className="form-group">
                                                                                                    <label htmlFor={`editEligibilityCodes`}>Eligibility Codes:</label>
                                                                                                    <select className="form-control" id={`editEligibilityCodes`}
                                                                                                        value={this.state.editStudent.decisionReason}
                                                                                                        style={{ marginRight: '20px' }}
                                                                                                        readOnly='true'
                                                                                                        /* onChange={(evt) => {
                                                                                                            const obj = { ...this.state.editStudent }
                                                                                                            obj.decisionReason = evt.target.value;
                                                                                                            obj.category = ((evt.target.selectedOptions[0] || {}).text || '');
                                                                                                            this.setState({ editStudent: obj });
                                                                                                        }}  */
                                                                                                        required>
                                                                                                        <option></option>
                                                                                                        {
                                                                                                            (this.state.eligibilityCodes || []).filter(code => {
                                                                                                                if (this.state.editStudent.isReducePriceEligible) {
                                                                                                                    return code.redElig === true

                                                                                                                } else if (this.state.editStudent.isFreeMealEligible) {
                                                                                                                    return code.freeElig === true
                                                                                                                } else {
                                                                                                                    return false
                                                                                                                }
                                                                                                            }).map((code, i) => {
                                                                                                                return <option value={code.code}>{code.codeDesc}</option>

                                                                                                            })
                                                                                                        }
                                                                                                    </select>
                                                                                                </div>
                                                                                            </div>
                                                                                            {
                                                                                                this.state.editStudent.isFreeMealEligible == true && this.state.editStudent.category === 'Free (TANF,SNAP,Foster)' ?
                                                                                                    <div className="col-xs-12">
                                                                                                        <div className="form-group">
                                                                                                            <label htmlFor={`editactualPrg`}>Specific Program:</label>
                                                                                                            <select className="form-control" id={`editactualPrg`}
                                                                                                                value={this.state.editStudent.actualPrg}
                                                                                                                readOnly='true'
                                                                                                                style={{ marginRight: '20px' }}
                                                                                                                /* onChange={(evt) => {
                                                                                                                    const obj = { ...this.state.editStudent }
                                                                                                                    obj.actualPrg = evt.target.value;
                                                                                                                    this.setState({ editStudent: obj });
                                                                                                                }}  */
                                                                                                                required>
                                                                                                                <option></option>
                                                                                                                <option>TANF</option>
                                                                                                                <option>SNAP</option>
                                                                                                                <option>Foster</option>

                                                                                                            </select>
                                                                                                        </div>
                                                                                                    </div> : null
                                                                                            }
                                                                                        </Fragment> : null
                                                                                }
                                                                            </Fragment>
                                                                            : null}
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-xs-12" style={{ marginTop: '37px' }}>
                                                                        <span style={{ margin: 10 }}>
                                                                            <input style={eligibleCheck}
                                                                                type="checkbox"
                                                                                name="editFreezePreOrder"
                                                                                id={"editFreezePreOrder"}
                                                                                readOnly='true'
                                                                                checked={this.state.editStudent.freezePreOrder}
                                                                                className="chb"

                                                                            />Freeze Account for Pre-ordering</span>
                                                                    </div>
                                                                </div>
                                                            </div></div></div>





                                                    <hr style={{ margin: '5px 0px' }} />
                                                </div>


                                            </form>
                                        </div>
                                        <div className="col-xs-12 col-sm-12 col-md-12">
                                            <div className="panel panel-primary">
                                                <div className="panel-body">


                                                    <div className="row">
                                                        <Tabs selectedIndex={this.state.modelTabIndex} onSelect={modelTabIndex => this.setState({ modelTabIndex })}>
                                                            <TabList>
                                                                <Tab tabFor="0">Transaction History</Tab>
                                                                <Tab tabFor="1">Deposits</Tab>
                                                                <Tab tabFor="2">Orders</Tab>
                                                                <Tab tabFor="3">Purchase</Tab>
                                                                <Tab tabFor="4">Eligibility History</Tab>

                                                            </TabList>
                                                            <TabPanel tabId="0">
                                                                <Fragment>  <AccountHistoryDistrict
                                                                    data={this.state.editStudent.displayRecId}
                                                                    mealSchoolId={this.state.editStudent.mSchoolId}
                                                                /></Fragment>
                                                            </TabPanel>
                                                            <TabPanel tabId="1">
                                                                <Fragment><StudentDepositsDistrict
                                                                    data={this.state.editStudent.displayRecId}
                                                                    finalBalance={this.state.editStudent.accBalance}
                                                                    parentDetails={this.state.editStudent.parentuser}
                                                                    studentId={this.state.editStudent.studentId}
                                                                    currency_symbol={this.state.userInfo.currencySymbol}
                                                                    mealSchoolId={this.state.editStudent.mSchoolId}
                                                                    year={this.state.editStudent.schoolYear}
                                                                /> </Fragment>
                                                            </TabPanel>
                                                            <TabPanel tabId="2">
                                                                <Fragment> <ViewOrdersDistrict
                                                                    data={this.state.editStudent.displayRecId}
                                                                    studentId={this.state.editStudent.studentId}
                                                                    mealSchoolId={this.state.editStudent.mSchoolId}
                                                                /></Fragment>
                                                            </TabPanel>
                                                            <TabPanel tabId="3">
                                                                <Fragment>
                                                                    <StudentPurchaseReportDistrict
                                                                        data={this.state.editStudent.displayRecId}
                                                                        studentName={this.state.editStudent.firstName + ' ' + this.state.editStudent.lastName}
                                                                        mealSchoolId={this.state.editStudent.mSchoolId}
                                                                    />
                                                                </Fragment>
                                                            </TabPanel>
                                                            <TabPanel tabId="4">
                                                                <Fragment> <BenefitsIssuanceReportDistrict
                                                                    data={this.state.editStudent.displayRecId}
                                                                    studentId={this.state.editStudent.studentId}
                                                                    mealSchoolId={this.state.editStudent.mSchoolId}
                                                                    year={this.state.editStudent.schoolYear}
                                                                /></Fragment>
                                                            </TabPanel>

                                                        </Tabs>

                                                    </div>
                                                </div></div></div>
                                    </div>)}


                            {this.state.lookupStatus === "false" &&

                                (
                                    <div>
                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <FreeReducedStudetsList selectedStudentsObj={this.state.selectionStuList} />
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-md-6 sectionTitle'>
                                                    <h2>
                                                        Student LookUp
                                                    </h2>
                                                </div>
                                                <div className='col-md-6 text-right'>
                                                    <div className='btn-group'>
                                                        <button className={this.state.showNewStudentOnly ? 'btn btn-xs btn-inactive-color' : 'btn btn-xs btn-inactive-color active'} style={{ fontSize: '13px' }} onClick={() => {
                                                            this.setState({ showNewStudentOnly: false }, () => {
                                                                this.filterList();
                                                            });
                                                        }}>All</button>
                                                        <button className={this.state.showNewStudentOnly ? 'btn btn-xs btn-inactive-color active' : 'btn btn-xs btn-inactive-color'} style={{ fontSize: '13px' }} onClick={() => {
                                                            this.setState({ showNewStudentOnly: true }, () => {
                                                                this.filterList(true);

                                                            });
                                                        }}>New Students</button>
                                                    </div>

                                                    <div className="btn-group">
                                                        <button className="btn btn-primary btn-sm dropdown-toggle bg-color-4" type="button"
                                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ fontSize: '13px' }}>
                                                            <i className="fa fa-file-excel-o" /> Export <span className="caret"></span>
                                                        </button>
                                                        <ul className="dropdown-menu">
                                                            <li>
                                                                <a title="Click to Download Excel" style={{ cursor: 'pointer' }}
                                                                    onClick={() => this.downloadExcel('ALL')}
                                                                    target='_blank'
                                                                > All Students</a>
                                                            </li>
                                                            <li>
                                                                <a title="Click to Download Excel" style={{ cursor: 'pointer' }}
                                                                    onClick={() => this.downloadExcel('ACTIVE')}
                                                                > Active Students</a>
                                                            </li>

                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="table-responsive">
                                                        <section className="clearfix">
                                                            <div className="tab-content">
                                                                <div className="media">
                                                                    <div className="panel panel-primary">
                                                                        <div className="panel-body">
                                                                            <div>
                                                                                {/* <Tabs>
                                                                                    <TabList>
                                                                                        {gradeList.map((item) => {
                                                                                            return <Tab onClick={() => {
                                                                                                this.state.tabIndex = item.value;
                                                                                                this.setState({ selectAll: false });
                                                                                                this.getDataByGrade(item.value);

                                                                                            }}> {item.label
                                                                                                }</Tab>
                                                                                        }, this)}
                                                                                    </TabList>
                                                                                    <TabPanel> */}
                                                                                <div className="row">

                                                                                    <div className="col-xs-3 pull-left">
                                                                                        <input type="text" value={search} onChange={(e) => {
                                                                                            this.setState({ search: e.target.value }, () => {
                                                                                                this.filterList()
                                                                                            })
                                                                                        }} className="form-control" placeholder="Search..." />
                                                                                    </div>
                                                                                    <div className="col-xs-3 pull-left" style={{ marginLeft: '-15px' }}>
                                                                                        <select className="form-control" value={this.state.selectedSchoolYear}
                                                                                            onChange={(e) => {
                                                                                                this.setState({ selectedSchoolYear: parseInt(e.target.value) }, () => {
                                                                                                    this.getDataByGrade(this.state.tabIndex);
                                                                                                    this.getDeletedStudents();
                                                                                                })
                                                                                            }}>
                                                                                            {(this.state.schoolYearOptions || []).map((y) => (
                                                                                                <option key={y} value={y}>{formatSchoolYearLabel(y)}</option>
                                                                                            ))}
                                                                                        </select>
                                                                                    </div>


                                                                                    <div className="col-xs-9">

                                                                                        <div className="pull-right" style={{
                                                                                            padding: '12px',
                                                                                            fontWeight: '600',
                                                                                            fontSize: '11px'
                                                                                        }}>
                                                                                            <lable style={{ marginRight: '100px' }}>New Students: {this.state.data.filter(s => s.sisNewStudent == true).length}</lable>
                                                                                            <lable>Total Students: {this.state.data.length}</lable>

                                                                                        </div>
                                                                                    </div>

                                                                                </div>
                                                                                {data ? (
                                                                                    <CheckboxTable
                                                                                        ref={r => (this.checkboxTable = r)}
                                                                                        data={_.orderBy(this.state.students, ['fullName'], ['asc'])}
                                                                                        columns={this.state.columns}
                                                                                        defaultPageSize={10}
                                                                                        className="-striped -highlight"
                                                                                        {...checkboxProps}
                                                                                    />) : null}
                                                                                {/* </TabPanel>

                                                                                     {gradeList.map(function (key) {
                                                                                        return (
                                                                                            <TabPanel>
                                                                                                <div className="row">
                                                                                                    <div className="col-xs-3 pull-left">
                                                                                                        <input type="text" id="search"
                                                                                                            className="form-control"
                                                                                                            style={{
                                                                                                                float: 'left',
                                                                                                                margin: '5px 0'
                                                                                                            }}
                                                                                                            name="search"
                                                                                                            placeholder="Search.."
                                                                                                            onKeyUp={this.filterSchool} />
                                                                                                    </div>
                                                                                                    <div className="col-xs-9">
                                                                                                        <div className="pull-right" style={{
                                                                                                            padding: '12px',
                                                                                                            fontWeight: '600',
                                                                                                            fontSize: '11px'
                                                                                                        }}>
                                                                                                            <lable style={{ marginRight: '100px' }}>New Students: {this.state.data.filter(s => s.sisNewStudent == true).length}</lable>
                                                                                                            <lable>Total Students: {this.state.data.length}</lable>

                                                                                                        </div>
                                                                                                    </div>


                                                                                                </div>
                                                                                                {data ? (
                                                                                                    <CheckboxTable
                                                                                                        ref={r => (this.checkboxTable = r)}
                                                                                                        data={_.orderBy(this.state.data, ['fullName'], ['asc'])}
                                                                                                        columns={this.state.columns}
                                                                                                        defaultPageSize={10}
                                                                                                        className="-striped -highlight"
                                                                                                        {...checkboxProps}
                                                                                                    />) : null}
                                                                                            </TabPanel>)
                                                                                    }, this)} 
                                                                            </Tabs>*/}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </section>
                                                    </div>
                                                </div>
                                            </div>
                                        </div></div>)}

                        </div>
                    </div >
                </section >
            </div >

        );
    }

}

export default StudentLookUpDistrict


// WEBPACK FOOTER //
// ./src/components/District/manageStudents/studentLookUpDistrict.jsx